<template>
  <div class="schoolSelectBackground">
    <p style="font-family: cookiebold; font-size: 28px; padding-top: 40px">
      {{ langlist[$store.state.lang]["학교 이름을 검색하여, 선택해주세요."] }}
    </p>
    <div style="padding-top: 20px;" v-show="!searchResult.length">
      <input
        @keyup.enter="search()"
        v-model="searchtext"
        autofocus
        type="text"
        :placeholder="langlist[$store.state.lang]['학교를 검색해주세요.']"
        class="selectinput"
      />
      <div @click="search()" class="searchBtn"></div>
    </div>
    <div v-show="searchResult.length">
      <div class="searchResultPanel">
        <div class="searchResultPanelTitle">
          <p class="searchResultTitle">
            {{ langlist[$store.state.lang]["검색 결과"] }}
          </p>
        </div>
        <div class="searchResultPanelContent">
          <div style="height: 10px"></div>
          <div
            class="searchResult"
            role="radiogroup"
            :aria-label="langlist[$store.state.lang]['검색 결과']"
          >
            <div
              class="searchResultElement"
              :class="{ searchResultElementOn: j.schoolCode === schoolCode }"
              v-for="(j, i) in searchResult"
              :key="i"
              role="radio"
              tabindex="0"
              :aria-checked="j.schoolCode === schoolCode"
              @click="selectSchool(j)"
              @keydown.enter.prevent="selectSchool(j)"
              @keydown.space.prevent="selectSchool(j)"
            >
              <div
                class="schoolRadio"
                :class="{ schoolRadioOn: j.schoolCode === schoolCode }"
              ></div>
              <p class="schoolName">
                {{ j.schoolName }}
              </p>
            </div>
          </div>
          <div style="margin-top: 10px; margin-left: 160px">
            <div @click="research()" class="btnstyle researchBtn"></div>
            <div
              @click="setschool()"
              class="btnstyle searchnextBtn"
              :class="{ btnstyleDisabled: !schoolCode }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { schoolSearch } from "@/api";
import { saveCookie } from "@/store/cookie";
import { ko, vt, en, zh, ja } from "@/_translate/translate.js";

export default {
  data() {
    return {
      searchtext: "",
      searchResult: [],
      schoolCode: "",
      schoolName: "",
      langlist: {
        ko,
        vt,
        en,
        zh,
        ja,
      },
    };
  },
  created() {
    this.searchtext = "";
    this.schoolCode = "";
    this.schoolName = "";
    this.searchResult = [];
  },
  methods: {
    gofree() {
      this.$emit("gofree");
    },
    async search() {
      this.searchResult = (await schoolSearch(this.searchtext)).data.data;
      if (!this.searchResult.length) {
        const event = new CustomEvent("error", {
          detail: {
            errortext:
              this.langlist[this.$store.state.lang]["검색 결과가 없습니다."],
          },
        });
        window.dispatchEvent(event);
      }
    },
    research() {
      this.searchtext = "";
      this.schoolCode = "";
      this.schoolName = "";
      this.searchResult = [];
    },
    selectSchool(data) {
      if (data.schoolCode === this.schoolCode) {
        this.schoolCode = "";
        this.schoolName = "";
      } else {
        this.schoolCode = data.schoolCode;
        this.schoolName = data.schoolName;
      }
    },
    setschool() {
      if (this.schoolCode) {
        saveCookie("schoolCode", this.schoolCode);
        const event = new CustomEvent("error", {
          detail: {
            errortext: this.langlist[this.$store.state.lang][
              "{{schoolName}} 으로 설정되었습니다."
            ].replace("{{schoolName}}", this.schoolName),
          },
        });
        window.dispatchEvent(event);
        this.$emit("setschool");
      }
    },
  },
};
</script>

<style scoped>
.schoolSelectBackground {
  /* background-color: rgba(204, 225, 255, 0.9); */
  background-image: url("../assets/Books_school_search_back.png");
  /* 원본 1300x587(비율 2.215)을 800x400(비율 2.0) 박스에 채운다.
     100%(=100% auto)면 높이가 361px로 모자라 아래쪽에 이미지가 반복된다 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 800px;
  height: 400px;
  border-radius: 40px;
  text-align: center;
  overflow: hidden;
}

input {
  background-color: #f4fbff;
  width: 90%;
  font-size: 120%;
  border-radius: 30px;
  border-bottom: 9px solid #607ccd;
  outline: none;
  height: 14%;
  padding-left: 80px;
  font-family: notosans;
}

.selectinput {
  background-image: url("../assets/Books_School_Icon.png");
  background-size: 5%;
  background-position-x: 20px;
  background-position-y: 15px;
  height: 80px;
  margin-left: 20px;
  margin-top: 20px;
}

.searchBtn {
  width: 200px;
  height: 60px;
  background-image: url("../assets/Books_school_search_btn.png");
  background-size: 100%;
  margin-top: 50px;
  cursor: pointer;
  margin-left: 300px;
}

.searchBtn:hover {
  filter: brightness(0.8);
}

.freeSigninBtn {
  width: 400px;
  height: 55px;
  background-image: url("../assets/Books_Free_Btn.png");
  background-size: 100%;
  cursor: pointer;
  margin-left: 200px;
  margin-top: 20px;
}

.freeSigninBtn:hover {
  filter: brightness(0.8);
}

.searchResultPanel {
  width: 90%;
  height: 290px;
  border-radius: 15px;
  margin-top: 20px;
  margin-left: 5%;
}

.searchResultPanelTitle {
  width: 100%;
  height: 40px;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-color: #607ccd;
  text-align: left;
}

.searchResultPanelContent {
  width: 100%;
  height: 240px;
  background-color: #f4fbff;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.searchResultTitle {
  font-size: 18px;
  color: white;
  margin-left: 20px;
  padding-top: 6px;
  font-family: notosans;
}

.searchResult {
  width: 90%;
  margin-left: 5%;
  height: 160px;
  overflow-y: auto;
  overflow-x: hidden;
  text-align: left;
}

/* 스크롤바를 지역 선택 패널과 동일하게 맞춘다 */
.searchResult::-webkit-scrollbar {
  width: 12px;
}

.searchResult::-webkit-scrollbar-track {
  background-color: #ffffff;
  border: 1px solid #607ccd;
  border-radius: 9px;
}

.searchResult::-webkit-scrollbar-thumb {
  background-color: #607ccd;
  border-radius: 9px;
}

/* 행 전체가 클릭 영역이며 hover/선택 상태를 배경으로 표시한다 */
.searchResultElement {
  display: flex;
  align-items: center;
  height: 52px;
  padding: 0 10px;
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.searchResultElement:hover {
  background-color: rgba(96, 124, 205, 0.12);
}

.searchResultElement:focus-visible {
  outline: 2px solid #607ccd;
  outline-offset: -2px;
}

.searchResultElementOn {
  background-color: rgba(96, 124, 205, 0.18);
}

.schoolRadio {
  width: 29px;
  height: 29px;
  border-radius: 50%;
  border: 2px solid rgba(13, 30, 82, 0.45);
  background-color: #ffffff;
  box-sizing: border-box;
  flex: none;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.searchResultElement:hover .schoolRadio {
  border-color: #607ccd;
}

.schoolRadioOn,
.searchResultElement:hover .schoolRadioOn {
  border-color: #0d1e52;
  background-color: #0d1e52;
  box-shadow: inset 0 0 0 3px #ffffff;
}

.schoolName {
  font-family: notosansregular;
  font-size: 20px;
  color: #0d1e52;
  margin: 0 0 0 11px;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.searchResultElementOn .schoolName {
  font-family: notosansmedium;
}

.btnstyle {
  background-size: 100%;
  width: 150px;
  height: 60px;
  float: left;
  cursor: pointer;
  transition: filter 0.15s ease;
}

.btnstyle:hover {
  filter: brightness(0.8);
}

/* 선택 전에는 눌러도 동작하지 않으므로 비활성으로 보이게 한다 */
.btnstyleDisabled,
.btnstyleDisabled:hover {
  filter: grayscale(0.8) opacity(0.45);
  cursor: default;
}

.researchBtn {
  background-image: url("../assets/researchBtn.png");
}

.searchnextBtn {
  background-image: url("../assets/searchnextBtn.png");
  margin-left: 100px;
}
</style>